// Centralised real media for the Blessed Algarve site.
// Assets uploaded by the client. More photos will be added in batches of 5.

const CDN = "https://customer-assets.emergentagent.com/job_blessed-photos-demo/artifacts";

export const assets = {
  // Weddings
  weddingRings: `${CDN}/hyr8mfzr_DSC_0245.jpg`,
  weddingKiss: `${CDN}/4zbt3wwf_DSC_0560.jpg`,

  // Family
  familyLaughingGirl: `${CDN}/9urpknw3_IMG_0135.jpg`,
  familyStairsGirl: `${CDN}/3oljtps1_IMG_0303.jpg`,
  familySeniorIntimate: `${CDN}/50p3n61h_IMG_8577.jpg`,
  familySeniorLaugh: `${CDN}/ue1gmhjf_IMG_8566.jpg`,

  // Portrait / Fashion / Studio
  portraitFurHood: `${CDN}/dd32x0af_IMG_0475.jpg`,
  portraitLashStudio: `${CDN}/zm2ggzni_IMG_4573.jpg`,

  // About / Brand
  aboutCouplePond: `${CDN}/o1je1ay2_IMG_9260.jpg`,

  // Contact section — distinct image per tab
  contactMessage: `${CDN}/dfvq3aiy_IMG_6316.jpg`,
  contactBooking: `${CDN}/ot2tmptb_IMG_9970.jpg`,

  // Christmas
  christmasBlueDress: `${CDN}/5pu8ng1q_IMG_6918.jpg`,
  christmasBoyTree: `${CDN}/1np2ds1u_IMG_7040.jpg`,
};

export const media = {
  heroVideo: "https://videos.pexels.com/video-files/3195394/3195394-uhd_2560_1440_25fps.mp4",
  heroFallback: assets.weddingKiss,
  about: assets.aboutCouplePond,
  contact: assets.weddingRings, // legacy fallback; ContactBooking picks per-tab

  portfolio: {
    weddings: [
      {
        src: assets.weddingKiss,
        alt: "Casal recém-casado beijando num jardim verdejante — Blessed Algarve",
        span: "lg:col-span-8 lg:row-span-2",
      },
      {
        src: assets.weddingRings,
        alt: "Alianças e buquê — detalhe de casamento Blessed Algarve",
        span: "lg:col-span-4 lg:row-span-1",
      },
    ],
    family: [
      {
        src: assets.familyLaughingGirl,
        alt: "Menina a rir com bokeh dourado ao pôr do sol",
        span: "lg:col-span-6 lg:row-span-2",
      },
      {
        src: assets.familyStairsGirl,
        alt: "Menina sentada em escadas rodeada de folhas de outono",
        span: "lg:col-span-6 lg:row-span-1",
      },
      {
        src: assets.familySeniorIntimate,
        alt: "Casal sénior num momento íntimo e terno ao ar livre",
        span: "lg:col-span-6 lg:row-span-1",
      },
      {
        src: assets.familySeniorLaugh,
        alt: "Casal sénior a rir com cumplicidade no jardim",
        span: "lg:col-span-6 lg:row-span-1",
      },
    ],
    fashion: [
      {
        src: assets.portraitLashStudio,
        alt: "Sessão editorial de beleza em estúdio com luz gold arch",
        span: "lg:col-span-12 lg:row-span-2",
      },
    ],
    christmas: [
      {
        src: assets.christmasBlueDress,
        alt: "Ensaio de Natal — mulher em vestido azul com luzes de fada junto à lareira",
        span: "lg:col-span-7 lg:row-span-2",
      },
      {
        src: assets.christmasBoyTree,
        alt: "Ensaio de Natal — menino maravilhado com os enfeites da árvore",
        span: "lg:col-span-5 lg:row-span-2",
      },
    ],
  },
};

export function getAllPortfolio() {
  const { weddings, family, fashion, christmas } = media.portfolio;
  const out = [];
  const max = Math.max(weddings.length, family.length, fashion.length, christmas.length);
  for (let i = 0; i < max; i++) {
    if (weddings[i]) out.push({ ...weddings[i], category: "weddings" });
    if (family[i]) out.push({ ...family[i], category: "family" });
    if (fashion[i]) out.push({ ...fashion[i], category: "fashion" });
    if (christmas[i]) out.push({ ...christmas[i], category: "christmas" });
  }
  return out;
}
